<template>
  <div>
    <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
      <div class="container">
        <h2 class="fsize32 sm-fsize24 font-bold text4F0A4B">Causes</h2>
        <p class="fsize16 sm-fsize14">
          Dementia is a complex condition that can impact memory, thinking, and
          social abilities. While the exact causes of dementia are not fully
          understood, there are several factors that can increase the risk of
          developing this condition. As a caregiver, it is important to be aware
          of these risk factors and understand how they can impact your loved
          one's health. <br />
          One of the most significant risk factors for dementia is age. As we
          age, our risk of developing dementia increases. This is due in part to
          changes in the brain that occur as we get older, including a reduction
          in the size of the brain and a decrease in the number of brain cells.
          While not everyone who gets older develops dementia, the risk does
          increase with age. <br />
          Genetics also play a role in the development of dementia. Research has
          shown that certain genes can increase the risk of developing dementia,
          particularly in cases of early-onset dementia. If you have a family
          history of dementia, it is important to be aware of this risk factor
          and discuss it with your loved one's healthcare provider. <br />
          Lifestyle factors can also impact the risk of developing dementia. For
          example, chronic health conditions such as high blood pressure,
          diabetes, and obesity have been linked to an increased risk of
          dementia. Lifestyle factors such as smoking, alcohol consumption, and
          lack of physical activity can also increase the probability of
          dementia. <br />
          Events that can contribute to the development of dementia include head
          injuries, infections, and exposure to toxins. Head injuries,
          particularly those that involve loss of consciousness, have been
          linked to an increased risk of dementia later in life. Infections such
          as HIV and Lyme disease have also been associated with an increased
          risk of dementia. Exposure to toxins such as lead and pesticides can
          also contribute to the development of dementia. <br />
          It is important to note that while these risk factors can increase the
          likelihood of developing dementia, not everyone who has these risk
          factors will develop the condition. Additionally, some people may
          develop dementia without any identifiable risk factors.
        </p>
        <div class="grid grid-cols-1 gap-8 mt-6">
          <div class="w-full lg:flex md:flex gap-4">
            <div class="lg:w-6/12 md:w-6/12 w-full mt-6">
              <h2 class="fsize24 text-primary mb-3">
                Tips for <span class="font-bold">Reducing the Risk</span> of
                Dementia
              </h2>
              <p class="fsize16 mb-8">
                As a caregiver, it is important to be aware of the risk factors
                for dementia and take steps to reduce the risk where possible.
              </p>
              <p class="fsize16">
                At Caregiversaathi, we understand the challenges of caring for
                someone with dementia. We offer a range of resources and support
                services for caregivers, including online forums, counseling
                services, and educational resources. Our goal is to help
                caregivers feel more confident and empowered in their caregiving
                role, and to provide a safe and supportive space for caregivers
                to connect with others who share their experiences. <br />
                In conclusion, dementia is a complex condition that can be
                caused by a variety of factors. While the exact causes of
                dementia are not fully understood, there are several risk
                factors that can increase the likelihood of developing the
                condition. As a caregiver, it is important to be aware of these
                risk factors and take steps to reduce the risk where possible.
                By encouraging a healthy lifestyle, managing chronic health
                conditions, protecting against head injuries, staying socially
                engaged, and seeking early treatment, you can help reduce the
                risk of dementia and improve your loved one's quality of life.
                At Caregiversaathi, we are here to support you every step of the
                way.
              </p>
            </div>
            <div class="lg:w-6/12 md:w-6/12 w-full lg:mt-0 md:mt-0 mt-4">
              <div class="grid grid-cols-2 gap-4 mt-6">
                <div class="card p-3">
                  <!-- <img
                    src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                    alt="dementia-cause"
                    class="causes-img object-cover"
                  /> -->
                  <!-- <div class="card p-3 text-center causes-img bgcceff2 fsize50">
                    1
                  </div> -->
                  <p class="fsize14 text-center text-black">
                    Encourage a healthy lifestyle: Encouraging your loved one to
                    maintain a healthy lifestyle can help reduce the risk of
                    dementia. This includes eating a balanced diet, getting
                    regular exercise, and avoiding smoking and excessive alcohol
                    consumption.
                  </p>
                </div>
                <div class="card p-3">
                  <!-- <img
                    src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                    alt="dementia-cause"
                    class="causes-img object-cover"
                  /> -->
                  <!-- <div class="card p-3 text-center causes-img bgcceff2 fsize50">
                    2
                  </div> -->
                  <p class="fsize14 text-center text-black">
                    Manage chronic health conditions: If your loved one has a
                    chronic health condition such as high blood pressure or
                    diabetes, it is important to work with their healthcare
                    provider to manage these conditions and reduce the risk of
                    complications.
                  </p>
                </div>
                <div class="card p-3">
                  <!-- <img
                    src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                    alt="dementia-cause"
                    class="causes-img object-cover"
                  /> -->
                  <!-- <div class="card p-3 text-center causes-img bgcceff2 fsize50">
                    3
                  </div> -->
                  <p class="fsize14 text-center text-black">
                    Protect against head injuries: Encourage your loved one to
                    wear protective headgear when engaging in activities that
                    carry a risk of head injury, such as cycling or playing
                    contact sports.
                  </p>
                </div>
                <div class="card p-3">
                  <!-- <img
                    src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                    alt="dementia-cause"
                    class="causes-img object-cover"
                  /> -->
                  <!-- <div class="card p-3 text-center causes-img bgcceff2 fsize50">
                    4
                  </div> -->
                  <p class="fsize14 text-center text-black">
                    Stay socially engaged: Social engagement has been linked to
                    a reduced risk of dementia. Encourage your loved one to
                    participate in social activities, such as clubs or volunteer
                    work, to promote cognitive stimulation and social
                    connection.
                  </p>
                </div>
                <div class="card p-3">
                  <!-- <img
                    src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                    alt="dementia-cause"
                    class="causes-img object-cover"
                  /> -->
                  <!-- <div class="card p-3 text-center causes-img bgcceff2 fsize50">
                    5
                  </div> -->
                  <p class="fsize14 text-center text-black">
                    Seek early treatment: If you notice any symptoms of dementia
                    in your loved one, seek early treatment. Early intervention
                    can help slow the progression of dementia and improve
                    quality of life.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
        <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
        <div class="lg:mt-10 md:mt-9 my-5">
          <h2 class="fsize32 sm-fsize24 font-bold text4F0A4B mb-4">Concern</h2>
          <p class="fsize16 sm-fsize14">
            As a caregiver, you may have noticed changes in your loved one's
            memory, thinking, or behavior that have caused you concern. These
            changes could be due to a variety of factors, but one possibility is
            dementia. If you suspect that your loved one may have dementia, it
            is important to seek a diagnosis so that you can get the support and
            resources you need to care for them. Diagnosing dementia can be a
            complex process that involves a variety of tests and assessments.
          </p>
        </div>
        <div class="lg:mt-10 md:mt-9 my-5">
          <h2 class="fsize24 sm-fsize16 text4F0A4B mb-4">
            What Caregivers can Expect during the
            <span class="font-bold">Diagnostic Process:</span>
          </h2>
          <p class="fsize16 sm-fsize14">
            It is important to note that there is no single test that can
            definitively diagnose dementia. Rather, a diagnosis is typically
            based on a combination of factors, including the results of
            cognitive assessments, imaging tests, laboratory tests, and
            evaluations by healthcare providers and specialists.
          </p>
        </div>

        <div class="w-full flex lg:mt-6 md:mt-0 mt-4 items-center gap-2 pb-6">
          <div class="lg:w-3/12 md:w-4/12 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Medical%20history%20and%20physical%20exam.jpg"
              alt="cancer"
              class="tab_img1 object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Laboratory%20tests.jpg"
              alt="cancer"
              class="tab_img2 object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Specialist%20consultations.jpg"
              alt="cancer"
              class="tab_img1 object-cover"
            />
          </div>
          <div
            class="lg:w-9/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4 text-dark"
          >
            <h2 class="fsize16 my-2 font-bold text4F0A4B">
              Medical history and physical exam
            </h2>
            <p class="fsize14">
              The first step in diagnosing dementia is to gather information
              about your loved one's medical history and conduct a physical
              exam. Your loved one's healthcare provider will ask questions
              about their symptoms, medical history, and medications, and will
              conduct a physical exam to check for any underlying health
              conditions that could be contributing to their symptoms.
            </p>
            <h2 class="fsize16 my-2 font-bold text4F0A4B">
              Cognitive assessments
            </h2>
            <p class="fsize14">
              Cognitive assessments are tests that are designed to measure your
              loved one's memory, thinking, and language abilities. These tests
              may include tasks such as recalling a list of words, performing
              simple math problems, or following instructions. The results of
              these tests can help healthcare providers determine if your loved
              one is experiencing cognitive decline and if further testing is
              needed.
            </p>
            <h2 class="fsize16 my-2 font-bold text4F0A4B">Imaging tests</h2>
            <p class="fsize14">
              Imaging tests, such as magnetic resonance imaging (MRI) or
              computed tomography (CT) scans, can help healthcare providers
              identify any structural changes or abnormalities in the brain that
              may be contributing to your loved one's symptoms.
            </p>
            <h2 class="fsize16 my-2 font-bold text4F0A4B">Laboratory tests</h2>
            <p class="fsize14">
              Laboratory tests can help rule out other conditions that may be
              causing your loved one's symptoms, such as vitamin deficiencies or
              thyroid problems.
            </p>
            <h2 class="fsize16 my-2 font-bold text4F0A4B">
              Psychological evaluations
            </h2>
            <p class="fsize14">
              Psychological evaluations can help healthcare providers assess
              your loved one's mood and behavior and determine if they are
              experiencing depression, anxiety, or other mental health
              conditions that may be contributing to their symptoms.
            </p>
            <h2 class="fsize16 my-2 font-bold text4F0A4B">
              Specialist consultations
            </h2>
            <p class="fsize14">
              Depending on your loved one's symptoms, they may need to see a
              specialist such as a neurologist, psychiatrist, or geriatrician
              for further evaluation.
            </p>
          </div>
        </div>
        <!-- <div class="grid grid-cols-2 gap-4 mt-6"> -->
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4">
            <!-- <img
                src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                alt="dementia-concern"
                class="concern-img1 object-cover"
              /> -->

            <!-- <img
              src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
              alt="cancer"
              class="tab_img1 object-cover"
            /> -->

            <!-- <div class="card p-3 text-center concern-img1 bgcceff2 fsize50">
                1
              </div> -->
          </div>
          <!-- <div class="lg:w-8/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize14 my-2 font-bold text4F0A4B">
              Medical history and physical exam
            </h2>
            <p class="fsize12">
              The first step in diagnosing dementia is to gather information
              about your loved one's medical history and conduct a physical
              exam. Your loved one's healthcare provider will ask questions
              about their symptoms, medical history, and medications, and will
              conduct a physical exam to check for any underlying health
              conditions that could be contributing to their symptoms.
            </p>
          </div> -->
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <!-- <div class="lg:w-4/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4"> -->
          <!-- <img
                src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                alt="dementia-concern"
                class="concern-img2 object-cover"
              /> -->
          <!-- <div class="card p-3 text-center concern-img1 bgcceff2 fsize50">
                2
              </div> -->
          <!-- </div> -->

          <!-- <div class="lg:w-8/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize14 my-2 font-bold text4F0A4B">
              Cognitive assessments
            </h2>
            <p class="fsize12">
              Cognitive assessments are tests that are designed to measure your
              loved one's memory, thinking, and language abilities. These tests
              may include tasks such as recalling a list of words, performing
              simple math problems, or following instructions. The results of
              these tests can help healthcare providers determine if your loved
              one is experiencing cognitive decline and if further testing is
              needed.
            </p>
          </div> -->
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4">
            <!-- <img
                src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                alt="dementia-concern"
                class="concern-img1 object-cover"
              /> -->
            <!-- <img
              src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
              alt="cancer"
              class="tab_img1 object-cover"
            /> -->
            <!-- <div class="card p-3 text-center concern-img1 bgcceff2 fsize50">
                3
              </div> -->
          </div>
          <!-- <div class="lg:w-8/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize14 my-2 font-bold text4F0A4B">Imaging tests</h2>
            <p class="fsize12">
              Imaging tests, such as magnetic resonance imaging (MRI) or
              computed tomography (CT) scans, can help healthcare providers
              identify any structural changes or abnormalities in the brain that
              may be contributing to your loved one's symptoms.
            </p>
          </div> -->
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <!-- <div class="lg:w-4/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4"> -->
          <!-- <img
                src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                alt="dementia-concern"
                class="concern-img2 object-cover"
              /> -->
          <!-- <div class="card p-3 text-center concern-img1 bgcceff2 fsize50">
                4
              </div> -->
          <!-- </div> -->
          <!-- <div class="lg:w-8/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize14 my-2 font-bold text4F0A4B">Laboratory tests</h2>
            <p class="fsize12">
              Laboratory tests can help rule out other conditions that may be
              causing your loved one's symptoms, such as vitamin deficiencies or
              thyroid problems.
            </p>
          </div> -->
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <div class="lg:w-4/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4">
            <!-- <img
                src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                alt="dementia-concern"
                class="concern-img1 object-cover"
              /> -->
            <!-- <div class="card p-3 text-center concern-img1 bgcceff2 fsize50">
                5
              </div> -->
          </div>
          <!-- <div class="lg:w-8/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize14 my-2 font-bold text4F0A4B">
              Psychological evaluations
            </h2>
            <p class="fsize12">
              Psychological evaluations can help healthcare providers assess
              your loved one's mood and behavior and determine if they are
              experiencing depression, anxiety, or other mental health
              conditions that may be contributing to their symptoms.
            </p>
          </div> -->
        </div>
        <div class="w-full lg:flex md:flex items-center gap-4">
          <!-- <div class="lg:w-4/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4"> -->
          <!-- <img
                src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                alt="dementia-concern"
                class="concern-img2 object-cover"
              /> -->
          <!-- <div class="card p-3 text-center concern-img1 bgcceff2 fsize50">
                6
              </div> -->
          <!-- </div> -->
          <!-- <div class="lg:w-8/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
            <h2 class="fsize14 my-2 font-bold text4F0A4B">
              Specialist consultations
            </h2>
            <p class="fsize14">
              Depending on your loved one's symptoms, they may need to see a
              specialist such as a neurologist, psychiatrist, or geriatrician
              for further evaluation.
            </p>
          </div> -->
        </div>
        <!-- </div> -->
        <!-- <div class="lg:mt-10 md:mt-9 my-5">
          <h2 class="fsize24 sm-fsize16 text4F0A4B mb-4">
            Some tips for Caregivers who are
            <span class="font-bold">Navigating a Diagnosis of Dementia: </span>
          </h2>
          <p class="fsize16 sm-fsize14">
            Receiving a diagnosis of dementia can be overwhelming for both the
            person with dementia and their caregivers. However, it is important
            to remember that a diagnosis can provide important information that
            can help you access the support and resources you need to care for
            your loved one.
          </p>
        </div> -->
        <div class="w-full grid grid-cols-2 gap-8">
          <div class="w-full lg:mt-0 md:mt-0 mt-4">
            <div class="m-3">
              <h2 class="fsize16 my-2 font-bold text4F0A4B">Seek support</h2>
              <p class="fsize14">
                Receiving a diagnosis of dementia can be emotional and
                overwhelming. It is important to seek out support from family,
                friends, and healthcare providers who can provide emotional and
                practical support.
              </p>
            </div>
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Seek%20support.jpg"
              alt="dementia-concern"
              class="concern-img3 object-cover"
            />
          </div>
          <div class="w-full lg:mt-0 md:mt-0 mt-4">
            <div class="m-3">
              <h2 class="fsize16 my-2 font-bold text4F0A4B">
                Educate yourself
              </h2>
              <p class="fsize14">
                Learning about dementia and its progression can help you better
                understand your loved one's condition and plan for their care.
                Caregiver Saathi offers a range of educational resources for
                caregivers who are caring for someone with dementia.
              </p>
            </div>
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Educate%20Yourself.jpg"
              alt="dementia-concern"
              class="concern-img4 object-cover"
            />
          </div>
          <div class="w-full lg:mt-0 md:mt-0 mt-4">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Plan%20for%20future.jpg"
              alt="dementia-concern"
              class="concern-img4 object-cover"
            />
            <div class="m-3">
              <h2 class="fsize16 my-2 font-bold text4F0A4B">
                Plan for the future
              </h2>
              <p class="fsize14">
                As dementia progresses, your loved one may require increasing
                levels of care and support. It is important to plan for their
                future care needs and make any necessary arrangements, such as
                arranging for home care or considering long-term care options.
              </p>
            </div>
          </div>
          <div class="w-full lg:mt-0 md:mt-0 mt-4">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Take%20care%20of%20yourself.jpg"
              alt="dementia-concern"
              class="concern-img3 object-cover"
            />
            <div class="m-3">
              <h2 class="fsize16 my-2 font-bold text4F0A4B">
                Take care of yourself
              </h2>
              <p class="fsize14">
                Caring for someone with dementia can be physically and
                emotionally taxing. It is important to prioritize your own
                self-care and seek out respite care when needed.
              </p>
            </div>
          </div>
        </div>
        <p class="fsize16 text-dark mt-8">
          At Caregiver Saathi, we understand the challenges of caring for
          someone with dementia and the importance of receiving a timely and
          accurate diagnosis. We offer a range of support services for
          caregivers, including online forums, counseling services, and
          educational resources. Our goal is to provide a safe and supportive
          space for caregivers to connect with others who share their
          experiences and to help caregivers feel more confident and empowered
          in their caregiving role.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.causes-img {
  /* align-items: center; */
  height: 100px;
  width: 70%;
  margin: 0 auto 10px auto;
}

.concern-img1 {
  height: 120px;
  width: 90%;
  border-radius: 0 75px 75px 75px;
  margin: 12px 0 12px 0;
}
.concern-img2 {
  height: 190px;
  width: 100%;
  border-radius: 75px 0 75px 75px;
  margin: 12px 0 12px 0;
}
.concern-img4 {
  height: 220px;
  width: 100%;
  border-radius: 80px 0 80px 0;
}
.concern-img3 {
  height: 220px;
  width: 100%;
  border-radius: 0 80px 0 80px;
}
</style>
